module.exports = __webpack_public_path__ + "static/img/ent-detail-61.08df627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-61.jpg
// module id = Cs1d
// module chunks = 52